let sdkPromise = null;
let initializedKey = null;

function initSdk(appId, version) {
  if (!window.FB) {
    throw new Error("Facebook SDK did not load.");
  }

  const nextKey = `${appId}:${version}`;
  if (initializedKey !== nextKey) {
    window.FB.init({
      appId,
      cookie: true,
      xfbml: false,
      version,
    });
    initializedKey = nextKey;
  }

  return window.FB;
}

export async function loadFacebookSdk({ app_id: appId, graph_version: graphVersion }) {
  if (window.FB) {
    return initSdk(appId, graphVersion);
  }

  if (!sdkPromise) {
    sdkPromise = new Promise((resolve, reject) => {
      const existingScript = document.getElementById("facebook-jssdk");

      window.fbAsyncInit = () => {
        try {
          resolve(initSdk(appId, graphVersion));
        } catch (error) {
          reject(error);
        }
      };

      if (existingScript) {
        return;
      }

      const script = document.createElement("script");
      script.id = "facebook-jssdk";
      script.async = true;
      script.defer = true;
      script.crossOrigin = "anonymous";
      script.src = "https://connect.facebook.net/en_US/sdk.js";
      script.onerror = () => reject(new Error("Unable to load the Facebook SDK."));
      document.body.appendChild(script);
    });
  }

  const sdk = await sdkPromise;
  return initSdk(appId, graphVersion) || sdk;
}

export function isAllowedFacebookOrigin(origin) {
  try {
    const { hostname, protocol } = new URL(origin);
    if (protocol !== "https:") {
      return false;
    }

    return hostname === "facebook.com"
      || hostname === "www.facebook.com"
      || hostname === "web.facebook.com"
      || hostname === "business.facebook.com"
      || hostname.endsWith(".facebook.com");
  } catch (error) {
    return false;
  }
}
